import $ from 'jquery';

import SwipeAndPaging from 'ui/swipeNpaging.js';

$(() => {
    $('#right-column-links').each((i, e) => {
        var rightBlockSwiper = new SwipeAndPaging({
            canLoadMore: false,
        });

        rightBlockSwiper.run($(e));
    });

    $('.js-popular-news-block').each((i, e) => {
        var popularBlock = new SwipeAndPaging();

        popularBlock.run($(e));
    });
});
